import { CREATE_DEAL_FAILURE, CREATE_DEAL_REQUEST, CREATE_DEAL_SUCCESS } from "../../../actions/opportunities/increaseDealSizeActions/createDealActions";

  const initialState = {
    createDealLoading: false,
    createDealData: [],
    createDealError: null,
  };
  
  const createDealReducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_DEAL_REQUEST:
        return { ...state, createDealLoading: true , payload: action.payload};
      case CREATE_DEAL_SUCCESS:
        return { ...state, createDealLoading: false, createDealData: action.payload };
      case CREATE_DEAL_FAILURE:
        return { ...state, createDealLoading: false, createDealError: action.payload };       
      default:
        return state;
    }
  };
  
  export default createDealReducer;
  